import { Components, Theme } from '@mui/material';

import { themeBase } from '../theme-base';

const { palette } = themeBase;

export const muiSnackbar: Theme['components'] = {
  MuiSnackbar: {
    styleOverrides: {
      root: {
        // Positioned notifications
      },
      anchorOriginBottomRight: {
        '@media (min-width: 600px)': {
          bottom: 24,
          right: 24,
        },
      },
    },
  } as Components['MuiSnackbar'],
  MuiAlert: {
    styleOverrides: {
      root: {
        borderRadius: 8,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)',
      },
      filledSuccess: {
        backgroundColor: palette.success.main,
        color: palette.common.white,
        '& .MuiAlert-icon': {
          color: palette.common.white,
        },
      },
      filledInfo: {
        backgroundColor: palette.mapBlue[500],
        color: palette.common.white,
        '& .MuiAlert-icon': {
          color: palette.common.white,
        },
      },
      filledWarning: {
        backgroundColor: palette.warning.main,
        color: palette.common.black,
        '& .MuiAlert-icon': {
          color: palette.common.black,
        },
      },
      filledError: {
        backgroundColor: palette.error.main,
        color: palette.common.white,
        '& .MuiAlert-icon': {
          color: palette.common.white,
        },
      },
      message: {
        padding: '8px 0',
        fontSize: 14,
        fontWeight: 500,
      },
      action: {
        paddingTop: 4,
      },
    },
  } as Components['MuiAlert'],
};
